export const BRAND_IMAGE_SOURCES = ['/brands/1.svg', '/brands/2.svg', '/brands/3.svg'];

function normalizeBrandKey(value = '') {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function findRegistryBrandImage(brand = '', registry = []) {
  const normalized = normalizeBrandKey(brand);
  if (!normalized) return '';
  const match = (Array.isArray(registry) ? registry : []).find((entry) => {
    const entryName = normalizeBrandKey(entry?.name || entry?.label || entry?.brand || entry?.slug || '');
    return entryName && entryName === normalized;
  });
  return String(match?.imageUrl || match?.logoUrl || match?.image || '').trim();
}

export function getBrandImageSrc(brand = '', registry = []) {
  const registryImage = findRegistryBrandImage(brand, registry);
  if (registryImage) return registryImage;
  const normalized = normalizeBrandKey(brand);
  if (!normalized) return '';

  if (normalized.includes('niuli')) return '/brands/1.svg';
  if (normalized.includes('jax') || normalized.includes('jac')) return '/brands/2.svg';
  if (normalized.includes('axor')) return '/brands/3.svg';

  let hash = 0;
  for (let index = 0; index < normalized.length; index += 1) {
    hash = (hash * 31 + normalized.charCodeAt(index)) >>> 0;
  }
  return BRAND_IMAGE_SOURCES[hash % BRAND_IMAGE_SOURCES.length];
}

export function getSecondaryBrandImageSrc(brand = '', registry = []) {
  const registryImage = findRegistryBrandImage(brand, registry);
  if (registryImage) return registryImage;
  const normalized = normalizeBrandKey(brand);
  if (!normalized) return '';

  if (normalized.includes('niuli')) return '/brands/2.svg';
  if (normalized.includes('jax') || normalized.includes('jac')) return '/brands/3.svg';
  if (normalized.includes('axor')) return '/brands/1.svg';

  let hash = 0;
  for (let index = 0; index < normalized.length; index += 1) {
    hash = (hash * 31 + normalized.charCodeAt(index)) >>> 0;
  }

  const primaryIndex = hash % BRAND_IMAGE_SOURCES.length;
  return BRAND_IMAGE_SOURCES[(primaryIndex + 1) % BRAND_IMAGE_SOURCES.length];
}
